import React, { CSSProperties, ReactNode } from "react"
import { View } from "@react-pdf/renderer"

const Table = ({
    children,
    border,
    style,
    fixed,
}: {
    children?: ReactNode
    border?: string
    style?: CSSProperties
    /** Repite la tabla completa en cada hoja que abarque su contenedor (encabezados sueltos) */
    fixed?: boolean
}) => {
    return (
        <View
            // ver nota en Row: `fixed` presente pero falsy tambien altera la paginacion
            {...(fixed ? { fixed: true } : {})}
            style={{ border: border ? border : "0.5px solid var(--placeholder))", ...(style as any) }}
        >
            {children}
        </View>
    )
}

export default Table
